import { recordRumError, recordRumEvent } from '../utils/rum';

const LOG_TYPE = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
};

export function logEvent(event, logType = LOG_TYPE.ERROR) {
  if (logType === LOG_TYPE.ERROR) {
    recordRumError(event);
  } else {
    recordRumEvent(logType, event);
  }
}
